import {Pipe, PipeTransform} from '@angular/core';
import CommercialFileStatusEnum from '../models/enums/commercialFileStatusEnum';
import CommercialFileEnergyStatusEnum from '../models/enums/commercialFileStatusEnergyEnum';
import CommercialFileEnergyEtatEnum from '../models/enums/commercialFileEnergyEtatEnum';

@Pipe({
    name: 'statusPipe'
})
export class CommercialFileStatusPipe implements PipeTransform {

    transform(status: string): string {
        if (status && CommercialFileStatusEnum.fromString(status)) {
            return CommercialFileStatusEnum.fromString(status).label;
        }
        if (status && CommercialFileEnergyStatusEnum.fromString(status)) {
            return CommercialFileEnergyStatusEnum.fromString(status)?.label;
        }
        if (status && CommercialFileEnergyEtatEnum.fromString(status)) {
            return CommercialFileEnergyEtatEnum.fromString(status)?.label;
        }
        return 'NOT_FOUND';
    }

}
